import axios from 'axios';
import jwt_decode from 'jwt-decode';

const TOKEN_KEY = 'token';

// Erro cuja mensagem já está pronta para ser exibida ao usuário.
export const STORAGE_BLOCKED_ERROR = 'StorageBlockedError';

class SessionHelper {

    // Token válido = existe, é decodificável e não expirou.
    // Qualquer outro caso limpa a sessão para não deixar credencial morta no navegador.
    static getValidToken() {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) {
            return null;
        }

        try {
            const { exp } = jwt_decode(token);
            if (exp !== undefined && Date.now() >= exp * 1000) {
                this.clear();
                return null;
            }
            return token;
        } catch (err) {
            console.log(err);
            this.clear();
            return null;
        }
    }

    static setToken(token) {
        try {
            localStorage.setItem(TOKEN_KEY, token);
        } catch (err) {
            // Safari privado / WebView podem bloquear o localStorage.
            console.log(err);
            const storageError = new Error('Não foi possível salvar sua sessão. Desative a navegação privada ou libere o armazenamento do site e tente novamente.');
            storageError.name = STORAGE_BLOCKED_ERROR;
            throw storageError;
        }
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    static applyAuthHeader(token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    // Sempre limpar os dois: um header default esquecido faz o próximo
    // login sair com o Bearer antigo e tomar 401.
    static clear() {
        try {
            localStorage.removeItem(TOKEN_KEY);
        } catch (err) {
            console.log(err);
        }
        delete axios.defaults.headers.common['Authorization'];
    }
}

export default SessionHelper;
